import L from 'leaflet';
import React, { Component } from 'react';
import { Map as LeafletMap, Pane, TileLayer } from 'react-leaflet';

import Railways from '../components/Railways';
import Stops from '../components/Stops';
import RouteBlockagesLayer from '../components/RouteBlockagesLayer';
import RidesLayer from '../components/RidesLayer';

/**
 * Fixes to get images working in Webpack.
 *
 * See also: https://github.com/PaulLeCam/react-leaflet/issues/255#issuecomment-261904061
 */
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const position = [52.238, 5.817];

export default class Map extends Component {
  constructor (props) {
    super(props);
    this.recalculateHeight = this.recalculateHeight.bind(this);

    this.state = {
      height: 500,
    };
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.recalculateHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.recalculateHeight);
  }

  componentDidMount() {
    setTimeout(() => this.recalculateHeight(), 500);
  }

  componentDidUpdate() {
    this.map.leafletElement.invalidateSize();
  }

  recalculateHeight() {
    this.setState({ height: (document.body.clientHeight - 65) });
  }

  render () {
    const { height } = this.state;

    return (
      <LeafletMap
        ref={ref => { this.map = ref; }}
        center={position}
        zoom={8}
        style={{ height }}
        className="no-user-select"
      >
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

        <Pane name="railways" style={{ zIndex: 499 }}>
          <Railways />
          <Stops />
        </Pane>
        <Pane name="blockages" style={{ zIndex: 500 }}>
          <RouteBlockagesLayer />
        </Pane>
        <Pane name="rides" style={{ zIndex: 501 }}>
          <RidesLayer />
        </Pane>
      </LeafletMap>
    );
  }
};
